import React, { Component } from "react";

class LineBreak extends Component {
  render() {
    return <hr />;
  }
}

export default LineBreak;